@if (showTableLoader) {
  <div class="table-loader">
    <sem-loader [showLoader]="true"></sem-loader>
  </div>
}

<br />

@if (hasNoItems) {
  <!-- Empty result: no card, no column headers, just the message -->
  <div class="table-data-no-records">
    <p>{{tr('galis_js_GridData_NoRecords', 'Ni zapisov.')}}</p>
  </div>
}

<div class="grid-table table-data-table" [hidden]="hasNoItems">
  <div class="table-container shadow">
    <!-- Same super-header structure as sem-data-grid: the legacy .table-manage / .table-controls are hidden in tailwind.css -->
    <div class="wg-grid-super-header">
      <div class="wg-grid-super-left">
        <span class="wg-grid-count-label">{{translationsService.translate('galis_js_GridData_itemsCount')}}:</span>
        <span class="wg-grid-count">{{totalItems | number}}</span>
      </div>
      <div class="wg-grid-super-right">
        @if (showPageSizeOption) {
          <div class="number-of-pages-setting">
            <label>{{translationsService.translate('galis_js_show')}}:</label>
            <div class="select-items">
              <select (change)="changeNumberOfPages($event)">
                @for (pageOption of pageOptions; track pageOption) {
                  <option value="{{pageOption}}">{{pageOption}} {{translationsService.translate('galis_js_recordsperpage')}}</option>
                }
              </select>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="table-data-wrapper">
      <ng-scrollbar [visibility]="'hover'" [track]="'all'">

        @if (itemsLoaded) {
          <table class="table table-hover table-data-control-table">
            <thead>
              <tr>
                @for (column of tableData.Columns; track column) {
                  <th class="sem-data-grid-th">
                    <p>{{column.HeaderText}}</p>
                    @if (helperColumnFlags[column.BindingField]?.IsSortable) {
                      <div class="sorting-container"
                        (click)="sortDropDownClick(column, $event)"
                        [ngClass]="{'sorting-container-used': helperColumnFlags[column.BindingField]?.SortingUsed}">
                        <span class="drop-down-sorting-icon">
                          <!--img src="../../../../../../Content/css/Images/arrow-down-s.png"
                          *ngIf="helperColumnFlags[column.BindingField]?.SortingUsed == false" /-->
                          <img src="/assets/css/images/platform/arrow-down-s.png" />
                        </span>
                        @if (helperColumnFlags[column.BindingField]?.ShowSort) {
                          <div class="drop-down-sorting-container">
                            <div class="drop-down-sorting-item" (click)="setColumnSorting(column,0,$event)">
                              <p><img src="/assets/css/images/platform/fill-10.png" />{{translationsService.translate('galis_js_GridData_Ascending')}}</p>
                            </div>
                            <div class="drop-down-sorting-item" (click)="setColumnSorting(column,1,$event)">
                              <p><img src="/assets/css/images/platform/filld-10.png" />{{translationsService.translate('galis_js_GridData_Descending')}}</p>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (helperColumnFlags[column.BindingField]?.SortingUsed) {
                      <div class="inuse-sorting-container">
                        @if (helperColumnFlags[column.BindingField]?.SortDirection == 0) {
                          <img src="/assets/css/images/platform/fill-10.png"
                            >
                        }
                        @if (helperColumnFlags[column.BindingField]?.SortDirection == 1) {
                          <img src="/assets/css/images/platform/filld-10.png"
                            />
                        }
                      </div>
                    }
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (dataItem of items; track dataItem) {
                <!-- matTooltip instead of the legacy .tooltip-text span: tailwind.css hides .grid-table .tooltip-text -->
                <tr class="grid-table-row" (click)="itemClick(dataItem)"
                  [matTooltip]="tooltipText" [matTooltipPositionAtOrigin]="true">
                  @for (column of tableData.Columns; track column) {
                    <td>
                      @if (column.IsBoolean == true) {
                        <div>
                          @if (resolvePropertyBinding(dataItem.Model, column.BindingField) == true) {
                            <div
                              class="boolean-grid-data">
                              <span class="true-circle boolean-circle"></span>
                              {{translationsService.translate('galis_js_GridData_BooleanTrue')}}
                            </div>
                          }
                          @if (resolvePropertyBinding(dataItem.Model, column.BindingField) == false) {
                            <div
                              class="boolean-grid-data">
                              <span class="false-circle boolean-circle"></span>
                              {{translationsService.translate('galis_js_GridData_BooleanFalse')}}
                            </div>
                          }
                        </div>
                      }
                      @if (showDataGridColumn(column.IsImageControl, column.IsBoolean)) {
                        <div>
                          @if (showIfNotDate(column.IsDateTime)) {
                            <p>
                              {{resolvePropertyBinding(dataItem.Model,column.BindingField)}}
                            </p>
                          }
                          @if (column.IsDateTime) {
                            <p>
                              {{resolvePropertyBinding(dataItem.Model,column.BindingField) | date:'dd.MM.yyyy': 'CET'}}
                            </p>
                          }
                        </div>
                      }
                    </td>
                  }
                  <td style="display:none;"></td>
                </tr>
              }
            </tbody>
          </table>
        }
      </ng-scrollbar>

    </div>

    @if (itemsLoaded) {
      <div class="table-footer pagination table-data-pagination">
        <div class="pagination-container">
          @if (previousPage > 0) {
            <div class="left-double" (click)="toFirstPage()"></div>
          }
          @if (previousPage > 0) {
            <div class="left" (click)="pageChanged(previousPage)"></div>
          }
          @for (page of pages; track page) {
            <p [ngClass]="{'active': page.Active == true}" (click)="pageChanged(page.Number)">{{page.Number}}</p>
          }
          @if (nextPage > 0) {
            <div class="right" (click)="pageChanged(nextPage)"></div>
          }
          @if (nextPage > 0) {
            <div class="right-double" (click)="toLastPage()"></div>
          }
        </div>
      </div>
    }

  </div>
</div>

